﻿import axios from "axios";

var needLoadingRequestCount = 0;
export default {
  install(Vue, options) {
    var cathayAxios = axios.create({
      baseURL: process.env.VUE_APP_API_HOST,
      headers: {
        get: {
          Accept: "application/json"
        },
        post: {
          "Content-Type": "application/json"
        },
        put: {
          "Content-Type": "application/json"
        },
        delete: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      }
    });

    let showRtnMessage = options.conf.SHOW_RTNMESSAGE != false;
    cathayAxios.interceptors.response.use(
      response => {
        tryHideFullScreenLoading();
        var resp = {};
        if (process.env.VUE_APP_API_MODE === "json-server") {
          if (response.status >= 200 && response.status <= 299) {
            resp.data = {};
            resp.data.returnCode = 0;
            resp.data.msg = "";
            resp.data.data = response.data;
            return resp.data;
          } else {
            Vue.$notify.error(response.data.msg || "伺服器維護中，請稍候再試!");
            return response.data;
          }
        }
        if (response.data && response.data.returnCode == 0) {
          if (
            response.data.msg &&
            response.data.msg.length > 0 &&
            showRtnMessage
          ) {
            Vue.$notify.success(response.data.msg);
          }
          return response.data;
        } else {
          if (showRtnMessage) {
            Vue.$notify.error(response.data.msg || "伺服器維護中，請稍候再試!");
          }
          return response.data;
        }
      },
      error => {
        tryHideFullScreenLoading();
        if (showRtnMessage) {
          Vue.$notify.error("伺服器維護中，請稍候再試!");
        }
        return Promise.resolve(error);
      }
    );

    cathayAxios.interceptors.request.use(config => {
      if (["development", "testing"].indexOf(process.env.NODE_ENV) > -1) {
        console.log("[CathayAxios] Request Url: " + config.url);
        if (process.env.VUE_APP_API_MODE === "static") {
          config.url = "static/data/" + config.url.split("?")[0] + ".json";
        }
      }

      config.headers['VUE-Referer'] = window.location.href;
      showFullScreenLoading();
      return config;
    });

    Vue.$cathayAxios = Vue.prototype.$cathayAxios = (method, url, req) => {
      switch (method) {
        case "get":
          Vue.$cathayAxios.get(url, body);
          break;
        case "post":
          Vue.$cathayAxios.post(url, body);
          break;
        case "put":
          Vue.$cathayAxios.put(url, body);
          break;
        case "delete":
          Vue.$cathayAxios.delete(url, body);
          break;
        default:
          Vue.$notify.error("伺服器維護中，請稍候再試!");
      }
    };
    Vue.$cathayAxios.get = Vue.prototype.$cathayAxios.get = (url, param) => {
      return cathayAxios.get(url, { params: param });
    };
    Vue.$cathayAxios.post = Vue.prototype.$cathayAxios.post = (url, body) => {
      return cathayAxios.post(url, body);
    };
    Vue.$cathayAxios.put = Vue.prototype.$cathayAxios.put = (url, body) => {
      return cathayAxios.put(url, body);
    };
    Vue.$cathayAxios.delete = Vue.prototype.$cathayAxios.delete = (
      url,
      body
    ) => {
      return cathayAxios.delete(url, { data: body });
    };
    Vue.$cathayAxios.upload = Vue.prototype.$cathayAxios.upload = (
      url,
      body
    ) => {
      if (process.env.VUE_APP_API_HOST != "/") {
        url = process.env.VUE_APP_API_HOST  + url;
      }
      showFullScreenLoading();
      return axios
        .post(url, body, {
          headers: {
            "Content-Type": " multipart/form-data;",
            "X-Requested-With": "XMLHttpRequest"
          }
        })
        .then(response => {
          tryHideFullScreenLoading();
          if (response.data && response.data.returnCode == 0) {
            if (
              response.data.msg &&
              response.data.msg.length > 0 &&
              showRtnMessage
            ) {
              Vue.$notify.success(response.data.msg);
            }
            return Promise.resolve(response.data);
          } else {
            Vue.$notify.error(response.data.msg);
            return Promise.resolve(response.data);
          }
        })
        .catch(error => {
          tryHideFullScreenLoading();
          if (showRtnMessage) {
            Vue.$notify.error("上傳檔案至伺服器發生錯誤!");
          }
          return Promise.resolve(error);
        });
    };

    Vue.$cathayAxios.download = Vue.prototype.$cathayAxios.download = (
      url,
      body,
      name
    ) => {
      if (process.env.VUE_APP_API_HOST != "/") {
        url = process.env.VUE_APP_API_HOST + url;
      }
      showFullScreenLoading();
      return new Promise((resolve, reject) => {
        axios
          .post(url, body, {
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded; charset=utf-8",
              "X-Requested-With": "XMLHttpRequest"
            },
            transformRequest: [
              function(data) {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ],
            responseType: "blob"
          })
          .then(resp => {
            tryHideFullScreenLoading();
            if (!resp.data || resp.data.type != "application/octet-stream") {
              // data convert to javascript object
              transBlobToObject(resp.data, function(data) {
                if (showRtnMessage) {
                  Vue.$notify.error("下載失敗! " + data.msg);
                }
                resolve(data);
              });
            } else {
              resolve(download(resp.data, name));
            }
          })
          .catch(err => {
            tryHideFullScreenLoading();
            reject(err.data);
          });
      });
    };

    // download
    function download(data, fileName) {
      if (!data) {
        return;
      }
      var blob = new Blob([data], {
        type: "application/octet-stream"
      });

      if (window.navigator.msSaveOrOpenBlob) {
        // FOR IE
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url); // 釋放資源
      }
    }

    function serializeParam(param) {
      var str = "";
      for (var key in param) {
        if (str != "") {
          str += "&";
        }
        str += encodeURIComponent(key) + "=" + encodeURIComponent(param[key]);
      }

      return str;
    }
    
    function showFullScreenLoading() {
      if (!Vue.$loader) return;
      if (needLoadingRequestCount === 0) {
        Vue.$loader.open();
      }
      needLoadingRequestCount++;
    }

    function tryHideFullScreenLoading() {
      if (!Vue.$loader) return;
      if (needLoadingRequestCount <= 0) return;

      needLoadingRequestCount--;
      if (needLoadingRequestCount === 0) {
        setTimeout(function() {
          Vue.$loader.close();
        }, 500);
      }
    }

    function transBlobToObject(blob, callBack) {
      reader.onload = function() {
        callBack(JSON.parse(this.result));
      };
      reader.readAsText(blob);
    }

    // create FileReader
    const reader = new FileReader();
  }
};
